<template lang="pug">
  .tosts
    b-toast#saved-notification(variant="success" no-close-button solid :auto-hide-delay="2000")
      | {{ $t('property.changes_saved') }}

    b-toast#set-password-notification(variant="success" no-close-button solid :auto-hide-delay="2000")
      | {{ $t('property.password_has_been_set') }}

    b-toast#error-loading(variant="danger" no-close-button solid :auto-hide-delay="2000")
      | {{ $t('property.error_loading') }}

    b-toast#delete-request-error(variant="danger" no-close-button solid :auto-hide-delay="2000")
      | {{ $t('property.user_has_not_delete') }}

    b-toast#set-password-error(variant="danger" no-close-button solid :auto-hide-delay="2000")
      | {{ $t('property.error_by_setting_password') }}

    b-toast#edit-profile-error(variant="danger" no-close-button solid :auto-hide-delay="2000")
      | {{ $t('edit_profile.error_by_saving') }}
</template>

<script>
  export default {}
</script>
